import {
  GET_RECOVERIES_REQUEST,
  GET_RECOVERIES_SUCCESS,
  GET_RECOVERIES_FAILURE,
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAILURE,
} from "../../constants/actionTypes";

const INITIAL_STATE = {
  data: [],
  paginacao: {},
  isFetching: true,
  isInitialFetching: true,
  isPosting: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_RECOVERIES_REQUEST:
      return { ...state, isFetching: true };
    case GET_RECOVERIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Items,
        paginacao: action.payload.Paging,
        isFetching: false,
        isInitialFetching: false,
      };
    case GET_RECOVERIES_FAILURE:
      return { ...state, isFetching: false, isInitialFetching: false };
    case DOWNLOAD_REPORT_REQUEST:
      return { ...state, isPosting: true };
    case DOWNLOAD_REPORT_SUCCESS:
      return { ...state, isPosting: false };
    case DOWNLOAD_REPORT_FAILURE:
      return { ...state, isPosting: false };
    default:
      return state;
  }
};
